import type { ReactNode } from "react";

import type { IconName } from "@luce/ui";
import { Box, ListItem, Skeleton } from "@luce/ui";

import { useClientProfile } from "../../shared";
import { ChangePhoneNumberButton } from "./components/change-phone-number-button";
import { InfoSection } from "./components/info-section";

interface DetailRowProps {
  icon: IconName;
  label: string;
  value?: string | null;
  divider?: boolean;
  trailing?: ReactNode;
}

function DetailRow({ icon, label, value, divider = true, trailing }: DetailRowProps) {
  return (
    <ListItem divider={divider}>
      <ListItem.LeadingIcon name={icon} color="neutral-foreground-intermediate" />
      <ListItem.Content>
        <ListItem.ContentSupportingText>{label}</ListItem.ContentSupportingText>
        <ListItem.ContentTitle>{value || "-"}</ListItem.ContentTitle>
      </ListItem.Content>
      {trailing ? <ListItem.Trailing>{trailing}</ListItem.Trailing> : null}
    </ListItem>
  );
}

export function AccountInfoDetails() {
  const { client, loading } = useClientProfile();

  return (
    <InfoSection title="Account">
      {loading ? (
        <Skeleton radius="lg" className="h-56 w-full" />
      ) : (
        <Box className="border-luce-neutral-border-mediumEmphasis rounded-radius-xl overflow-hidden border">
          <DetailRow icon="UserCircle" label="Account Type" value={client?.accountType} />
          <DetailRow icon="Envelope" label="Email" value={client?.user?.email} />
          <DetailRow
            icon="Phone"
            label="Phone Number"
            value={client?.user?.phoneNumber}
            divider={false}
            trailing={<ChangePhoneNumberButton />}
          />
        </Box>
      )}
    </InfoSection>
  );
}
